import React from 'react';
import { GiFlowerEmblem } from "react-icons/gi";
import "./Splitter.css";

const Splitter = () => {
  return (
    <div className='splitter'>
        <hr />
        <GiFlowerEmblem className='flower' />
        <hr/>
    </div>
  )
}

export default Splitter